"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatePDF = void 0;
var core_1 = require("@blueprintjs/core");
var react_1 = __importDefault(require("react"));
var PDFDocument_1 = require("./PDFDocument");
var CreatePDF = (function (_super) {
    __extends(CreatePDF, _super);
    function CreatePDF() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            PDFDialog: false
        };
        return _this;
    }
    CreatePDF.prototype.render = function () {
        var _this = this;
        var PDFDialog = this.state.PDFDialog;
        var props = this.props;
        return (react_1.default.createElement("div", { className: "relative" },
            react_1.default.createElement(core_1.Button, { text: props.title, intent: "warning", onClick: function () { return _this.setState({ PDFDialog: true }); } }),
            react_1.default.createElement(core_1.Dialog, { isOpen: PDFDialog, canOutsideClickClose: true, className: "bg-white", style: { width: "95vw", height: "95vh" }, onClose: function () {
                    _this.setState({ PDFDialog: false });
                    document.title = "React App";
                } },
                react_1.default.createElement(PDFDocument_1.PdfDocument, { prescription: props.prescription, doctorName: props.doctorName, header: JSON.parse(props.header), footer: JSON.parse(props.footer), signatureImage: props.signatureImage }))));
    };
    return CreatePDF;
}(react_1.default.Component));
exports.CreatePDF = CreatePDF;
//# sourceMappingURL=index.js.map